import { createPaginatedList } from "MODULES/shared/pagination";
import api from "APP_ROOT/api";
import { List } from "immutable";
import { combineReducers } from "redux";
import { ID } from "APP_ROOT/constants";
import createStore from "APP_ROOT/createStore";

export const searchLineItems = pageInfo => (dispatch, getState) => {
  const results = getState()
    .repairOrderDetail.getIn(["repairOrder", "line_items"], List())
    .toJS();
  const { limit, page } = pageInfo.query;
  const data = {
    total_count: results.length,
    results: results.slice(limit * page - limit, page * limit)
  };

  return Promise.resolve({ data });
};

export const repairOrderLineItems = createPaginatedList({
  listId: "repairOrderLineItems",
  fetch: searchLineItems,
  initialSettings: {
    pageSize: 5
  }
});

export const reservedForRepairInventory = createPaginatedList({
  listId: "reservedForRepairInventory",
  fetch: api.inventories.searchReservedForRepair
});

export const repairOrdersPagination = createPaginatedList({
  listId: "repairOrders/search",
  stateLocator: state => state.repairOrders.search,
  fetch: api.repairOrders.search,
  initialSettings: {
    sort: "created_at",
    sortReverse: true
  }
});

export const repairOrderLineItemsPagination = createPaginatedList({
  listId: "repairOrders/lineItems",
  stateLocator: state => state.repairOrders.lineItems,
  initialSettings: {
    pageSize: 15
  },
  fetch: search => {
    const id = createStore()
      .getState()
      .repairOrderDetail.getIn(["repairOrder", ID]);
    return api.repairOrders.lineItems.search(id, search);
  }
});

export default combineReducers({
  search: repairOrdersPagination.paginator,
  lineItems: repairOrderLineItemsPagination.paginator
});



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/pagination.js